import React from "react";

import classes from "../screens/Planner/Custom.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDrum,
  faDrumstickBite,
  faUtensils,
  faPizzaSlice,
  faSignOutAlt,
  faRunning,
  faSwimmer,
  faBiking,
  faWalking,
  faHeartbeat,
  faStickyNote,
  faHamburger,
  faBreadSlice,
  faHotdog,
  faFish,
  faCookieBite,
  faHotTub,
  faDumbbell,
} from "@fortawesome/free-solid-svg-icons";

const Meal = () => {
  return (
    <svg
      width="35"
      height="40"
      viewBox="0 0 35 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9282 15.0488L21.379 13.8541L23.1427 11.7289L24.6919 12.9274L22.9282 15.0488ZM14.0818 19.9119L19.4961 16.1631L21.085 17.3885L20.4733 18.7632L22.3005 19.529L23.4922 16.8217L19.5596 13.7852L12.9219 18.3802L14.0818 19.9119ZM34.8649 2.42007C34.8021 1.88644 34.5769 1.38266 34.2178 0.972106C33.8586 0.561549 33.3815 0.262557 32.8465 0.112749C32.3115 -0.0370599 31.7425 -0.0309927 31.211 0.130187C30.6796 0.291366 30.2095 0.600458 29.8598 1.01857L22.6422 9.70706L27.0474 13.1074C34.8292 3.73732 35.0358 3.91346 34.8649 2.42007ZM35 27.1874C34.9975 27.6719 34.8951 28.1511 34.6988 28.5971C34.5025 29.0431 34.2163 29.447 33.8567 29.7855C33.4971 30.124 33.0713 30.3902 32.604 30.5686C32.1368 30.7471 31.6374 30.8343 31.1349 30.8252H30.408V33.3716C30.4103 34.2531 30.2301 35.1262 29.8781 35.9397C29.526 36.7533 29.0092 37.491 28.3578 38.1096C27.7064 38.7283 26.9335 39.2155 26.0844 39.5427C25.2354 39.8699 24.3271 40.0306 23.4128 40.0153H11.6826C7.79367 40.0153 4.58802 37.1204 4.58802 33.3716V30.8099H3.86506C2.86422 30.8099 1.90436 30.4266 1.19666 29.7444C0.488954 29.0622 0.0913696 28.1369 0.0913696 27.1721C0.0913696 26.2073 0.488954 25.2821 1.19666 24.5998C1.90436 23.9176 2.86422 23.5344 3.86506 23.5344H4.58802V21.2368H30.408V23.5344H31.1349C31.6388 23.5252 32.1394 23.6129 32.6077 23.7923C33.076 23.9718 33.5025 24.2393 33.8623 24.5794C34.2221 24.9195 34.5081 25.3253 34.7034 25.7731C34.8987 26.2209 34.9996 26.7017 35 27.1874ZM4.58802 25.4643H3.86506C3.39098 25.4643 2.93631 25.6458 2.60108 25.969C2.26585 26.2921 2.07752 26.7304 2.07752 27.1874C2.07752 27.6444 2.26585 28.0827 2.60108 28.4059C2.93631 28.729 3.39098 28.9106 3.86506 28.9106H4.58802V25.4643ZM26.8329 23.9326H24.8468V34.2715H26.8329V23.9326ZM31.1349 25.4643H30.408V28.9106H31.1349C31.6111 28.9106 32.0678 28.7282 32.4045 28.4036C32.7413 28.0791 32.9304 27.6388 32.9304 27.1798C32.9304 26.7207 32.7413 26.2805 32.4045 25.9559C32.0678 25.6313 31.6111 25.449 31.1349 25.449V25.4643ZM12.6597 15.2556H14.6459C14.6459 14.2945 15.4404 14.1068 15.4404 12.5062C15.4404 10.9056 14.6459 10.6912 14.6459 9.65728C14.6459 8.70764 15.4404 8.30174 15.4404 6.83132H13.4542C13.4542 7.9035 11.8335 9.10971 13.1761 11.5183C14.054 13.0959 12.6597 13.4023 12.6597 15.2556ZM7.59109 17.1702H9.57724C9.57724 16.2052 10.3717 16.0214 10.3717 14.4208C10.3717 12.8202 9.57724 12.6058 9.57724 11.5757C9.57724 10.6146 10.3717 10.2278 10.3717 8.74593H8.38555C8.38555 9.82194 6.76485 11.0243 8.10749 13.4329C8.98537 15.0105 7.59109 15.3169 7.59109 17.1702Z"
        fill="#88B058"
      />
    </svg>
  );
};

const EatOut = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1956 25.4768L17.4785 13.7273L3.78898 0H2.71914L2.50069 0.556616C1.92413 2.02579 1.67778 3.52844 1.78837 4.90192C1.91444 6.46754 2.50758 7.823 3.50377 8.82194L14.1905 19.5382L15.6001 18.1247L25.48 29.2028C26.4628 30.1883 28.1545 30.2468 29.1956 29.2028C30.2201 28.1755 30.2201 26.504 29.1956 25.4768Z"
        fill="#825A31"
      />
      <path
        d="M8.77149 17.6259L0.737461 25.6636C-0.24582 26.6474 -0.24582 28.2481 0.737461 29.2319C1.67156 30.1664 3.28748 30.2489 4.30404 29.2319L12.3381 21.1941L8.77149 17.6259Z"
        fill="#825A31"
      />
      <path
        d="M28.702 5.04796L23.8643 9.88552L22.6023 8.62354L27.4399 3.78591L26.1779 2.52392L21.3403 7.36149L20.0784 6.0995L24.916 1.26193L23.6541 0L17.3441 6.30995C16.5722 7.08188 16.1113 8.10683 16.0461 9.19613C16.0296 9.47212 15.967 9.74358 15.8633 10.0018L19.9622 14.1007C20.2204 13.9968 20.4919 13.9343 20.7679 13.9179C21.8572 13.8529 22.8821 13.3918 23.6541 12.6199L29.964 6.31001L28.702 5.04796Z"
        fill="#825A31"
      />
    </svg>
  );
};

function icon(icon, iconClass = classes.placeholderIcon) {
  switch (icon) {
    case "run":
      return <FontAwesomeIcon className={iconClass} icon={faRunning} />;
    case "treat":
      return <FontAwesomeIcon className={iconClass} icon={faPizzaSlice} />;
    case "custom":
      return <FontAwesomeIcon className={iconClass} icon={faStickyNote} />;
    case "walk":
      return <FontAwesomeIcon className={iconClass} icon={faWalking} />;
    case "swim":
      return <FontAwesomeIcon className={iconClass} icon={faSwimmer} />;
    case "cycle":
      return <FontAwesomeIcon className={iconClass} icon={faBiking} />;
    case "hiit":
      return <FontAwesomeIcon className={iconClass} icon={faHeartbeat} />;
    case "weights":
      return <FontAwesomeIcon className={iconClass} icon={faDumbbell} />;
    case "eatout":
      return (
        <div className={iconClass}>
          <EatOut />
        </div>
      );
    case "hamburger":
      return <FontAwesomeIcon className={iconClass} icon={faHamburger} />;
    case "cookie":
      return <FontAwesomeIcon className={iconClass} icon={faCookieBite} />;
    case "bread":
      return <FontAwesomeIcon className={iconClass} icon={faBreadSlice} />;
    case "hotdog":
      return <FontAwesomeIcon className={iconClass} icon={faHotdog} />;
    case "drumstick":
      return <FontAwesomeIcon className={iconClass} icon={faDrumstickBite} />;
    case "fish":
      return <FontAwesomeIcon className={iconClass} icon={faFish} />;
    case "hottub":
      return <FontAwesomeIcon className={iconClass} icon={faHotTub} />;
    case "meal":
      return (
        <div className={iconClass}>
          <Meal />
        </div>
      );

    default:
      return <FontAwesomeIcon className={iconClass} icon={faUtensils} />;
  }
}

const CustomIcon = (props) => {
  return icon(props.icon, props.className);
};

export default CustomIcon;
